import { Plane, Building2, Briefcase, Sunset, Palmtree, Gem, Camera, Sparkles } from 'lucide-react';
import { Reveal, SectionHeading } from './Reveal';
import { SERVICES } from '../data/content';

const ICONS = { Plane, Building2, Briefcase, Sunset, Palmtree, Gem, Camera, Sparkles };

const Services = () => (
  <section id="services" data-testid="services-section" className="scroll-mt-24 border-y border-white/5 bg-[#0a0a0a] py-28 lg:py-36">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <SectionHeading eyebrow="Services" title={<>Every occasion,<br /><span className="italic text-gold">elevated.</span></>} />
      <div className="grid grid-cols-1 gap-px border border-white/5 bg-white/5 sm:grid-cols-2 lg:grid-cols-4">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.title} delay={(i % 4) * 0.08} className="h-full">
              <div
                data-testid={`service-card-${s.title.toLowerCase().replace(/\s+/g, '-')}`}
                onClick={s.href ? () => document.querySelector(s.href)?.scrollIntoView({ behavior: 'smooth' }) : undefined}
                className={`group flex h-full flex-col bg-[#0a0a0a] p-8 transition-colors duration-500 hover:bg-surface ${s.href ? 'cursor-pointer' : ''}`}
              >
                <Icon className="h-7 w-7 text-gold transition-transform duration-500 group-hover:-translate-y-1" strokeWidth={1.25} />
                <h3 className="font-display mt-6 text-xl tracking-tight text-white transition-colors duration-300 group-hover:text-gold">{s.title}</h3>
                <p className="mt-3 text-sm font-light leading-relaxed text-white/50">{s.text}</p>
                <div className="mt-auto pt-6">
                  <div className="h-px w-8 bg-gold/40 transition-all duration-500 group-hover:w-16 group-hover:bg-gold" />
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default Services;
